<template>
  <div class="form">
    <img
      :src="data.Maindata.formulaire[0].trackingForm"
      alt="tracking"
      class="tracking"
      v-if="image"
    />
    <form
      @submit="SubmitForm"
      class="form"
      method="POST"
      action="send/FormBasique.php"
      id="formulaire"
    >
      <div class="title">
        <picture>
          <source :srcset="darklogo" media="(prefers-color-scheme:dark)" />
          <img class="home__formsection__logo" :src="logo" alt="Hyundai" />
        </picture>
        <h2 v-if="!error">{{ data.Maindata.formulaire[0].titleForm }}</h2>
        <h3 v-if="!error">{{ data.Maindata.formulaire[0].subtitleForm }}</h3>
      </div>
      <div class="row" v-if="selectVehicleOption">
        <fieldset class="offre">
          <select
            :class="{ selected: input_selectmodel !== '' }"
            id="js_input_selectmodel"
            v-model="input_selectmodel"
            name="car"
            class="formlp"
          >
            <option value="" disabled selected>Sélectionner un véhicule</option>
            <option
              v-for="(item, index) in selectoption"
              :key="index"
              :value="item.list[0].slug"
              class="option"
            >
              {{ item.list[0].title }}
            </option>
          </select>

          <div
            :class="{ active: input_selectmodel !== '' }"
            class="select__offre"
            v-if="!data.Maindata.formulaire[0].selectVehicle"
          >
            <div class="select__offre__transi"></div>
            <div class="select__offre__right">
              <img
                v-if="select_clearcutSrc"
                :src="select_clearcutSrc"
                alt="hyundai"
                width="auto"
                height="auto"
              />

              <img
                v-if="select_offreSrc"
                :src="select_offreSrc"
                alt="offre"
                width="auto"
                height="auto"
              />
              <span @click="DisplayML">Voir conditions</span>
            </div>
          </div>
        </fieldset>
      </div>

      <div class="row">
        <fieldset>
          <select
            :class="{ selected: input_selectgender !== '' }"
            id="js_input_selectgender"
            v-model="input_selectgender"
            name="civilite"
            class="formlp"
          >
            <option selected disabled value="">Civilité</option>
            <option value="Mme">Madame</option>
            <option value="Mr">Monsieur</option>
          </select>
        </fieldset>
      </div>

      <div class="row">
        <fieldset>
          <label
            class="labelAnim"
            :class="{ activeLabel: input_firstname !== '' }"
            for="js_input_firstname"
            name="firstname"
            >Prénom</label
          >
          <input
            class="formlp vueverif"
            data-regex="^[a-zA-Z-' ]+$"
            v-model="input_firstname"
            id="js_input_firstname"
            name="firstname"
          />
        </fieldset>

        <fieldset>
          <label
            class="labelAnim"
            :class="{ activeLabel: input_lastname !== '' }"
            for="js_input_lastname"
            name="lastname"
            >Nom</label
          >
          <input
            class="formlp vueverif"
            data-regex="^[a-zA-Z-' ]+$"
            v-model="input_lastname"
            id="js_input_lastname"
            name="lastname"
          />
        </fieldset>
      </div>

      <div class="row">
        <fieldset>
          <label
            class="labelAnim"
            :class="{ activeLabel: input_email !== '' }"
            for="js_input_email"
            name="email"
            >Email</label
          >
          <input
            class="formlp vueverif"
            data-regex="^(?!.*\.{2})[a-zA-Z0-9!#$%&'*+/=?^_{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_{|}~-]+)*@[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?)+$"
            v-model="input_email"
            id="js_input_email"
            name="email"
          />
        </fieldset>
        <fieldset>
          <label
            class="labelAnim"
            :class="{ activeLabel: input_tel !== '' }"
            for="js_input_tel"
            name="tel"
            >N° de téléphone</label
          >
          <input
            class="formlp vueverif"
            data-regex="^(01|02|03|04|05|06|07|09) \d{2} \d{2} \d{2} \d{2}$"
            v-mask="'## ## ## ## ##'"
            v-model="input_tel"
            id="js_input_tel"
            name="tel"
            autocomplete="one-time-code"
          />
        </fieldset>
      </div>

      <div class="row">
        <fieldset>
          <label
            class="labelAnim"
            :class="{ activeLabel: input_zipcode !== '' }"
            for="js_input_zipcode"
            name="zipcode"
            >Code postal</label
          >
          <input
            class="formlp vueverif"
            data-regex="^\d{5}$"
            v-mask="'#####'"
            v-model="input_zipcode"
            id="js_input_zipcode"
            name="zipcode"
          />
        </fieldset>
        <fieldset v-if="!errorAPI">
          <select
            :class="{ selected: input_selectcity !== '' }"
            id="js_input_selectcity"
            v-model="input_selectcity"
            name="city"
            class="formlp"
          >
            <option selected disabled value="">Ville</option>
            <option
              v-for="(item, index) in select_city"
              :key="index"
              :value="item.nom_de_la_commune"
            >
              {{ item.nom_de_la_commune }}
            </option>
          </select>
        </fieldset>

        <fieldset v-else>
          <label
            class="labelAnim"
            :class="{ activeLabel: input_selectcity !== '' }"
            for="js_input_selectcity"
            name="city"
            >Ville</label
          >
          <input
            class="formlp vueverif"
            v-model="input_selectcity"
            id="js_input_selectcity"
            name="city"
          />
        </fieldset>
      </div>

      <div class="row">
        <fieldset class="offre">
          <select
            :class="{ selected: input_selectconcess !== '' }"
            id="js_input_selectconcess"
            v-model="input_selectconcess"
            class="formlp"
            name="concess"
          >
            <option value="" disabled selected>
              Sélectionner un distributeur
            </option>
            <option
              v-for="(item, index) in select_concess"
              :key="index"
              :value="item.sap"
              v-if="item.zip"
            >
              {{ item.zip.substring(0, 2) }} - {{ item.name }}
            </option>
            <option
              v-for="(item, index) in select_concess"
              :key="index"
              :value="item.sap"
              v-if="!item.zip"
            >
              {{ item.name }}
            </option>
          </select>
        </fieldset>
      </div>

      <div class="row" v-if="optin === true">
        <p class="title_optin">Personnalisation de votre expérience Hyundai</p>
      </div>

      <div class="row">
        <fieldset v-if="optin === true">
          <label class="customcheckbox">
            Je souhaite recevoir des communications personnalisées et des
            publicités ciblées basées sur mes préférences et mon utilisation des
            produits et services de Hyundai Motor France et de son réseau de
            distributeurs et réparateurs agréés. Pour cela, Hyundai Motor France
            créera mon profil client individuel.
            <details>
              <summary class="details">En savoir plus</summary>
              En cochant cette case, vous acceptez que Hyundai Motor France vous
              adresse des communications personnalisées par courrier
              électronique, téléphone, courrier et/ou services de messagerie
              ainsi que des publicités ciblées sur internet et sur les réseaux
              sociaux.
              <br /><br />
              Pour cela Hyundai Motor France créera un profil client individuel
              basé sur vos préférences et intérêts combinant des données sur
              votre utilisation de nos produits et services et de nos sites et
              applications, des données sur la façon dont vous interagissez avec
              nos campagnes marketing, des données socio-économiques ainsi que
              des données relatives à l’utilisation de votre véhicule.
              <br /><br />
              Pour vous adresser des publicités ciblées sur internet sur les
              réseaux sociaux, nous serons amenés à transférer vos données
              personnelles à des sociétés tierces.
            </details>

            <input
              type="checkbox"
              id="js_input_news"
              v-model="input_news"
              name="optin"
              class="formlp"
            />
            <span class="customcheckbox__checkmark"></span>
          </label>
        </fieldset>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <p class="title_optin">
            Je comprends que je peux modifier ou retirer mon consentement au
            traitement de mes données personnelles à tout moment.
          </p>

          <details>
            <summary class="details">En savoir plus</summary>
            Vos préférences
            <br /><br />
            Vous pouvez modifier en ligne le degré de présence de Hyundai que
            vous souhaitez dans votre vie. Pour modifier ou retirer votre
            consentement,
            <a
              href="https://hyundai-europe-privacy.my.onetrust.com/ui/#/preferences/multipage/login/9e77c974-41a8-427d-b896-0399e53f4efb"
              target="_blank"
              >cliquez ici</a
            >
            ou cliquez sur le lien de désabonnement dans chaque communication
            que nous vous envoyons.
            <br />
            <br />
            Remarque : le retrait ou la modification de votre consentement
            n'affecte pas la légalité du traitement fondé sur le consentement
            avant son retrait ou sa modification.
          </details>
          <br />
          Pour plus d'informations sur le traitement de mes données personnelles
          et de mes droits, je peux me référer à la
          <a
            class="personnal-data"
            href="https://www.hyundai.com/fr/fr/rgpd.html"
            target="_blank"
            >politique traitement de mes données personnelles</a
          >
        </div>
      </div>

      <div class="row">
        <button v-if="!postformValid" class="sendForm">
          <span>
            <span>{{
              this.error === true
                ? "Confirmer"
                : data.Maindata.formulaire[0].ctaForm
            }}</span>
          </span>
        </button>
        <button v-if="postformValid" class="sendForm">
          <span>
            <span>{{
              this.error === true
                ? "Confirmer"
                : data.Maindata.formulaire[0].ctaForm
            }}</span>
          </span>
        </button>
      </div>
      <input type="hidden" :value="data.Maindata.campaign" name="campaign" />
      <input
        type="hidden"
        :value="data.Maindata.formulaire[0].TypeValue"
        name="type"
      />

      <input type="hidden" :value="utmParteners" name="parteners" />
      <input type="hidden" :value="utmSource" name="source" />
      <input type="hidden" :value="randuniq" name="randuniq" />
      <input type="hidden" :value="iid" name="iid" />
    </form>
  </div>
</template>

<script>
import Vue from "vue";
import VueMask from "v-mask";
Vue.use(VueMask);
import axios from "axios";

//JS
import FormValidation from "@/assets/js/FormValidation";
import stores from "@/assets/js/store/store";
import {
  input_zipcodeConcess,
  reordonnerParDistance,
} from "@/assets/js/store/concessDistance";
import { modeleVehicle } from "@/assets/js/store/modeleVehicle";
import { ToggleML, ToggleRGPD } from "@/assets/js/ToggleML";
import Manage from "@/assets/js/ManageForm";
import { useApiStore } from "@/pinia/api";

import logo from "@/assets/img/Hyundai_Logo.svg";
import darklogo from "@/assets/img/Hyundai_Logo_dark.svg";

export default {
  name: "FormBasique",

  props: {
    data: Object,
    error: Boolean,
    scenario: String,
    utmSource: String,
    utmParteners: String,
    modele: String,
    postformValid: Boolean,
    optin: Boolean,
    randuniq: String,
    formParams: Object,
  },

  data() {
    return {
      api: useApiStore(),
      mentions: null,
      logo: logo,
      darklogo: darklogo,
      selectVehicleOption: true,
      //CHAMPS FORMUALIRE
      input_selectmodel: "",
      input_email: "",
      input_tel: "",
      input_selectgender: "",
      input_firstname: "",
      input_lastname: "",
      input_zipcode: "",
      input_selectcity: "",
      input_news: "",
      input_news2: "",
      input_selectconcess: "",
      campaign: "",
      iid: "",

      //AUTRE
      valideform: true,
      selectoption: [],
      select_clearcutSrc: "",
      select_offreSrc: "",
      select_concess: "",
      select_city: [],
      errorAPI: false,
      optionsCiv: ["Mr", "Mme"],
      value: "",
      show: false,
      image: false,
    };
  },

  watch: {
    //WATCH LE CHAMPS MODEL
    async input_selectmodel(newValue, oldValue) {
      // find the new value in the selectoption array
      const selectedModel = this.selectoption.find(
        (model) => model.list[0].slug === newValue
      );
      this.mentions = selectedModel.list[0].slug;

      if (!this.data.Maindata.formulaire[0].selectVehicle) {
        this.ArraySelectModele = await modeleVehicle(
          selectedModel.list[0].slug,
          this.selectoption,
          this.api.baseUrl,
          stores.bloclist
        );
        this.select_clearcutSrc = this.ArraySelectModele[0];
        this.select_offreSrc = this.ArraySelectModele[1];
      }
    },

    input_selectcity(newValue) {
      if (newValue !== "") {
        const selectedCity = this.select_city.find(
          (city) => city.nom_de_la_commune === newValue
        );
        if (selectedCity) {
          const lat = selectedCity.coordonnees_geographiques[0];
          const lng = selectedCity.coordonnees_geographiques[1];
          reordonnerParDistance(this.select_concess, lat, lng);
          this.input_selectconcess = this.select_concess[0].sap;
        }
      }
    },

    //WATCH LE CHAMPS CODE POSTAL
    async input_zipcode(newValue, oldValue) {
      this.ArrayInput = await input_zipcodeConcess(
        newValue,
        this.select_concess
      );
      this.input_selectconcess = this.ArrayInput[0];
      this.select_city = this.ArrayInput[1];
      this.input_selectcity = this.ArrayInput[2];
      this.errorAPI = this.ArrayInput[3];
      if (this.select_city.length >= 1) {
        this.select_city.forEach((city) => {
          if (city.nom_de_la_commune === this.formParams.city) {
            this.input_selectcity = city.nom_de_la_commune;
          }
        });
      }
    },
  },

  mounted() {
    // console.log(this.data.Maindata);
    this.FetchData();
    const urlParams = new URLSearchParams(window.location.search);
    this.iid = urlParams.get("iid") || "";
  },

  methods: {
    initParams() {
      if (this.formParams.gender === "Mme" || this.formParams.gender === "Mr") {
        this.input_selectgender = this.formParams.gender;
      }
      if (this.formParams.firstname !== undefined)
        this.input_firstname = this.formParams.firstname;
      if (this.formParams.lastname !== undefined)
        this.input_lastname = this.formParams.lastname;
      if (this.formParams.email !== undefined)
        this.input_email = this.formParams.email;
      if (this.formParams.phone !== undefined)
        this.input_tel = this.formParams.phone;
      if (this.formParams.cp !== undefined)
        this.input_zipcode = this.formParams.cp;
    },

    DisplayRGPD() {
      ToggleRGPD();
    },

    postForm() {
      let postformView = document.getElementById("postform");
      if (postformView) {
        postformView.classList.add("active");
      }
    },

    //LIS DE PARAMETRE MODEL DE L'URL POUR AFFICHER LE BON MODELE DANS LE SELECT
    InitSelect() {
      const model = Manage.ManageSelectModel();

      for (let i = 0; i < this.selectoption.length; i++) {
        if (this.selectoption[i].list[0].slug === model) {
          this.select_clearcutSrc =
            this.api.baseUrl +
            "/i?" +
            this.selectoption[i].list[0].images[0].path;

          this.input_selectmodel = this.selectoption[i].list[0].slug;
          stores.slug_mention = this.selectoption[i].list[0].slug;
        }
      }
    },

    DisplayML() {
      ToggleML();
      stores.slug_mention = this.input_selectmodel;
      // stores.slug_mention = "bayon";
    },

    async FetchData() {
      // console.log(this.error);
      if (this.error === true) {
        axios
          .get(this.api.baseUrl, {
            headers: {
              "xc-api-token": this.api.xcToken,
              "x-table-id": this.api.Modeles,
            },
          })
          .then((res) => {
            this.selectoption = res.data.list;

            // Appelez votre fonction InitSelect ici si nécessaire
            this.InitSelect();
          });
      } else {
        const modelelist = this.data.Maindata.formulaire[0].modeleForm;
        if (modelelist === undefined) {
          this.selectVehicleOption = false;
        } else {
          var myHeaders = new Headers();
          myHeaders.append("xc-api-token", this.api.xcToken);
          myHeaders.append("x-table-id", this.api.Modeles);
          var requestOptions = {
            method: "GET",
            headers: myHeaders,
            redirect: "follow",
          };
          console.log(modelelist);
          const fetchPromises = modelelist.map((item) =>
            typeof item === "object"
              ? fetch(
                  `${this.api.baseUrl}?where=(slug,eq,${item[0]})`,
                  requestOptions
                )
                  .then((response) => response.json())
                  .catch((error) => {
                    // Vous pouvez gérer les erreurs ici si nécessaire
                  })
              : fetch(
                  `${this.api.baseUrl}?where=(slug,eq,${item})`,
                  requestOptions
                )
                  .then((response) => response.json())
                  .catch((error) => {
                    // Vous pouvez gérer les erreurs ici si nécessaire
                  })
          );

          // Utilisez Promise.all pour attendre la fin de toutes les requêtes fetch
          Promise.all(fetchPromises)
            .then((results) => {
              // remove all the empty array
              results = results.filter((el) => el.list.length !== 0);

              // Toutes les requêtes fetch sont terminées ici, et les résultats sont dans le tableau "results"
              this.selectoption = results;
              if (this.selectoption.length < 1) {
                this.selectVehicleOption = false;
              }

              //console.log("Toutes les requêtes fetch sont terminées");

              // this.$nextTick est utilisé ici pour s'assurer que le DOM est mis à jour

              this.$nextTick(() => {
                let option = document.querySelectorAll(".option");

                if (option.length === 1) {
                  option[0].selected = true;
                  this.input_selectmodel = option[0].value;
                }

                // Appelez votre fonction InitSelect ici si nécessaire

                this.InitSelect();
                this.selectModele();
              });
            })
            .catch((error) => {
              //console.log("Erreur lors de l'attente des requêtes fetch", error);
            });
        }
      }
      //FETCH DE LA LISTE DE TOUTES LE CONCESSIONS
      var myHeaders = new Headers();
      myHeaders.append("xc-api-token", this.api.xcToken);
      myHeaders.append("x-table-id", this.api.Dealer);

      var requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };
      fetch(
        this.api.baseUrl +
          "?where=(status,eq,ACTIVE)&sort=zip&limit=550&fields=zip,name,sap,lat,lng",
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          this.select_concess = result.list;
          this.initParams();
        })
        .catch((error) => console.log("error", error));
    },

    selectModele() {
      // select modele if the parameter modele is in the url with number

      this.selectoption.forEach((item) => {
        if (item.list[0].slug === this.modele) {
          this.input_selectmodel = this.modele;
        }
      });
    },

    SubmitForm: function (e) {
      var form = document.getElementById("formulaire");
      e.preventDefault();
      const valid = FormValidation(this.scenario, "formlp");

      // Si le formulaire n'est pas valide, on arrête l'exécution de la fonction
      if (!valid) {
        return;
      } else {
        //Affichage du component de confirmation si le formulaire est valide
        if (!this.postformValid) {
          const confirmComponent = document.querySelector(".confirm");
          confirmComponent.classList.add("active");
        } else {
          this.postForm();
        }
      }

      let b = null,
        ee = null;

      switch (this.data.Maindata.formulaire[0].TypeValue) {
        case "leadgensms":
          (b = document.getElementsByTagName("body")[0]),
            (ee = document.createElement("img"));
          (ee.src =
            "https://tbl.tradedoubler.com/report?organization=1865651&event=442372&leadNumber=auto"),
            b.parentNode.appendChild(ee, b);
          break;

        case "rtg":
          // https://stackoverflow.com/a/33486055
          var MD5Inliner = function (d) {
            var r = M(V(Y(X(d), 8 * d.length)));
            return r.toLowerCase();
          };
          function M(d) {
            for (
              var _, m = "0123456789ABCDEF", f = "", r = 0;
              r < d.length;
              r++
            )
              (_ = d.charCodeAt(r)),
                (f += m.charAt((_ >>> 4) & 15) + m.charAt(15 & _));
            return f;
          }
          function X(d) {
            for (var _ = Array(d.length >> 2), m = 0; m < _.length; m++)
              _[m] = 0;
            for (m = 0; m < 8 * d.length; m += 8)
              _[m >> 5] |= (255 & d.charCodeAt(m / 8)) << m % 32;
            return _;
          }
          function V(d) {
            for (var _ = "", m = 0; m < 32 * d.length; m += 8)
              _ += String.fromCharCode((d[m >> 5] >>> m % 32) & 255);
            return _;
          }
          function Y(d, _) {
            (d[_ >> 5] |= 128 << _ % 32), (d[14 + (((_ + 64) >>> 9) << 4)] = _);
            for (
              var m = 1732584193,
                f = -271733879,
                r = -1732584194,
                i = 271733878,
                n = 0;
              n < d.length;
              n += 16
            ) {
              var h = m,
                t = f,
                g = r,
                e = i;
              (f = md5_ii(
                (f = md5_ii(
                  (f = md5_ii(
                    (f = md5_ii(
                      (f = md5_hh(
                        (f = md5_hh(
                          (f = md5_hh(
                            (f = md5_hh(
                              (f = md5_gg(
                                (f = md5_gg(
                                  (f = md5_gg(
                                    (f = md5_gg(
                                      (f = md5_ff(
                                        (f = md5_ff(
                                          (f = md5_ff(
                                            (f = md5_ff(
                                              f,
                                              (r = md5_ff(
                                                r,
                                                (i = md5_ff(
                                                  i,
                                                  (m = md5_ff(
                                                    m,
                                                    f,
                                                    r,
                                                    i,
                                                    d[n + 0],
                                                    7,
                                                    -680876936
                                                  )),
                                                  f,
                                                  r,
                                                  d[n + 1],
                                                  12,
                                                  -389564586
                                                )),
                                                m,
                                                f,
                                                d[n + 2],
                                                17,
                                                606105819
                                              )),
                                              i,
                                              m,
                                              d[n + 3],
                                              22,
                                              -1044525330
                                            )),
                                            (r = md5_ff(
                                              r,
                                              (i = md5_ff(
                                                i,
                                                (m = md5_ff(
                                                  m,
                                                  f,
                                                  r,
                                                  i,
                                                  d[n + 4],
                                                  7,
                                                  -176418897
                                                )),
                                                f,
                                                r,
                                                d[n + 5],
                                                12,
                                                1200080426
                                              )),
                                              m,
                                              f,
                                              d[n + 6],
                                              17,
                                              -1473231341
                                            )),
                                            i,
                                            m,
                                            d[n + 7],
                                            22,
                                            -45705983
                                          )),
                                          (r = md5_ff(
                                            r,
                                            (i = md5_ff(
                                              i,
                                              (m = md5_ff(
                                                m,
                                                f,
                                                r,
                                                i,
                                                d[n + 8],
                                                7,
                                                1770035416
                                              )),
                                              f,
                                              r,
                                              d[n + 9],
                                              12,
                                              -1958414417
                                            )),
                                            m,
                                            f,
                                            d[n + 10],
                                            17,
                                            -42063
                                          )),
                                          i,
                                          m,
                                          d[n + 11],
                                          22,
                                          -1990404162
                                        )),
                                        (r = md5_ff(
                                          r,
                                          (i = md5_ff(
                                            i,
                                            (m = md5_ff(
                                              m,
                                              f,
                                              r,
                                              i,
                                              d[n + 12],
                                              7,
                                              1804603682
                                            )),
                                            f,
                                            r,
                                            d[n + 13],
                                            12,
                                            -40341101
                                          )),
                                          m,
                                          f,
                                          d[n + 14],
                                          17,
                                          -1502002290
                                        )),
                                        i,
                                        m,
                                        d[n + 15],
                                        22,
                                        1236535329
                                      )),
                                      (r = md5_gg(
                                        r,
                                        (i = md5_gg(
                                          i,
                                          (m = md5_gg(
                                            m,
                                            f,
                                            r,
                                            i,
                                            d[n + 1],
                                            5,
                                            -165796510
                                          )),
                                          f,
                                          r,
                                          d[n + 6],
                                          9,
                                          -1069501632
                                        )),
                                        m,
                                        f,
                                        d[n + 11],
                                        14,
                                        643717713
                                      )),
                                      i,
                                      m,
                                      d[n + 0],
                                      20,
                                      -373897302
                                    )),
                                    (r = md5_gg(
                                      r,
                                      (i = md5_gg(
                                        i,
                                        (m = md5_gg(
                                          m,
                                          f,
                                          r,
                                          i,
                                          d[n + 5],
                                          5,
                                          -701558691
                                        )),
                                        f,
                                        r,
                                        d[n + 10],
                                        9,
                                        38016083
                                      )),
                                      m,
                                      f,
                                      d[n + 15],
                                      14,
                                      -660478335
                                    )),
                                    i,
                                    m,
                                    d[n + 4],
                                    20,
                                    -405537848
                                  )),
                                  (r = md5_gg(
                                    r,
                                    (i = md5_gg(
                                      i,
                                      (m = md5_gg(
                                        m,
                                        f,
                                        r,
                                        i,
                                        d[n + 9],
                                        5,
                                        568446438
                                      )),
                                      f,
                                      r,
                                      d[n + 14],
                                      9,
                                      -1019803690
                                    )),
                                    m,
                                    f,
                                    d[n + 3],
                                    14,
                                    -187363961
                                  )),
                                  i,
                                  m,
                                  d[n + 8],
                                  20,
                                  1163531501
                                )),
                                (r = md5_gg(
                                  r,
                                  (i = md5_gg(
                                    i,
                                    (m = md5_gg(
                                      m,
                                      f,
                                      r,
                                      i,
                                      d[n + 13],
                                      5,
                                      -1444681467
                                    )),
                                    f,
                                    r,
                                    d[n + 2],
                                    9,
                                    -51403784
                                  )),
                                  m,
                                  f,
                                  d[n + 7],
                                  14,
                                  1735328473
                                )),
                                i,
                                m,
                                d[n + 12],
                                20,
                                -1926607734
                              )),
                              (r = md5_hh(
                                r,
                                (i = md5_hh(
                                  i,
                                  (m = md5_hh(
                                    m,
                                    f,
                                    r,
                                    i,
                                    d[n + 5],
                                    4,
                                    -378558
                                  )),
                                  f,
                                  r,
                                  d[n + 8],
                                  11,
                                  -2022574463
                                )),
                                m,
                                f,
                                d[n + 11],
                                16,
                                1839030562
                              )),
                              i,
                              m,
                              d[n + 14],
                              23,
                              -35309556
                            )),
                            (r = md5_hh(
                              r,
                              (i = md5_hh(
                                i,
                                (m = md5_hh(
                                  m,
                                  f,
                                  r,
                                  i,
                                  d[n + 1],
                                  4,
                                  -1530992060
                                )),
                                f,
                                r,
                                d[n + 4],
                                11,
                                1272893353
                              )),
                              m,
                              f,
                              d[n + 7],
                              16,
                              -155497632
                            )),
                            i,
                            m,
                            d[n + 10],
                            23,
                            -1094730640
                          )),
                          (r = md5_hh(
                            r,
                            (i = md5_hh(
                              i,
                              (m = md5_hh(m, f, r, i, d[n + 13], 4, 681279174)),
                              f,
                              r,
                              d[n + 0],
                              11,
                              -358537222
                            )),
                            m,
                            f,
                            d[n + 3],
                            16,
                            -722521979
                          )),
                          i,
                          m,
                          d[n + 6],
                          23,
                          76029189
                        )),
                        (r = md5_hh(
                          r,
                          (i = md5_hh(
                            i,
                            (m = md5_hh(m, f, r, i, d[n + 9], 4, -640364487)),
                            f,
                            r,
                            d[n + 12],
                            11,
                            -421815835
                          )),
                          m,
                          f,
                          d[n + 15],
                          16,
                          530742520
                        )),
                        i,
                        m,
                        d[n + 2],
                        23,
                        -995338651
                      )),
                      (r = md5_ii(
                        r,
                        (i = md5_ii(
                          i,
                          (m = md5_ii(m, f, r, i, d[n + 0], 6, -198630844)),
                          f,
                          r,
                          d[n + 7],
                          10,
                          1126891415
                        )),
                        m,
                        f,
                        d[n + 14],
                        15,
                        -1416354905
                      )),
                      i,
                      m,
                      d[n + 5],
                      21,
                      -57434055
                    )),
                    (r = md5_ii(
                      r,
                      (i = md5_ii(
                        i,
                        (m = md5_ii(m, f, r, i, d[n + 12], 6, 1700485571)),
                        f,
                        r,
                        d[n + 3],
                        10,
                        -1894986606
                      )),
                      m,
                      f,
                      d[n + 10],
                      15,
                      -1051523
                    )),
                    i,
                    m,
                    d[n + 1],
                    21,
                    -2054922799
                  )),
                  (r = md5_ii(
                    r,
                    (i = md5_ii(
                      i,
                      (m = md5_ii(m, f, r, i, d[n + 8], 6, 1873313359)),
                      f,
                      r,
                      d[n + 15],
                      10,
                      -30611744
                    )),
                    m,
                    f,
                    d[n + 6],
                    15,
                    -1560198380
                  )),
                  i,
                  m,
                  d[n + 13],
                  21,
                  1309151649
                )),
                (r = md5_ii(
                  r,
                  (i = md5_ii(
                    i,
                    (m = md5_ii(m, f, r, i, d[n + 4], 6, -145523070)),
                    f,
                    r,
                    d[n + 11],
                    10,
                    -1120210379
                  )),
                  m,
                  f,
                  d[n + 2],
                  15,
                  718787259
                )),
                i,
                m,
                d[n + 9],
                21,
                -343485551
              )),
                (m = safe_add(m, h)),
                (f = safe_add(f, t)),
                (r = safe_add(r, g)),
                (i = safe_add(i, e));
            }
            return Array(m, f, r, i);
          }
          function md5_cmn(d, _, m, f, r, i) {
            return safe_add(
              bit_rol(safe_add(safe_add(_, d), safe_add(f, i)), r),
              m
            );
          }
          function md5_ff(d, _, m, f, r, i, n) {
            return md5_cmn((_ & m) | (~_ & f), d, _, r, i, n);
          }
          function md5_gg(d, _, m, f, r, i, n) {
            return md5_cmn((_ & f) | (m & ~f), d, _, r, i, n);
          }
          function md5_hh(d, _, m, f, r, i, n) {
            return md5_cmn(_ ^ m ^ f, d, _, r, i, n);
          }
          function md5_ii(d, _, m, f, r, i, n) {
            return md5_cmn(m ^ (_ | ~f), d, _, r, i, n);
          }
          function safe_add(d, _) {
            var m = (65535 & d) + (65535 & _);
            return (((d >> 16) + (_ >> 16) + (m >> 16)) << 16) | (65535 & m);
          }
          function bit_rol(d, _) {
            return (d << _) | (d >>> (32 - _));
          }

          let md5 = MD5Inliner(this.input_email.toLowerCase());
          (function (cm_p, cm_id, ep, qs, b) {
            cm_p = [];
            cm_id = "5f173bb7-f3d4-4d3a-adf2-6cb27839ba31";
            cm_p.push(["h", md5]);
            cm_p.push(["action", "sale"]);
            cm_p.push(["order_id", ""]);
            cm_p.push(["w", window.location.hostname]),
              (ep = "//tr.cloud-media.fr/t/" + cm_id),
              (qs = cm_p
                .map(function (a) {
                  return a[0] + "=" + encodeURI(a[1]);
                })
                .join("&")),
              (b = document.getElementsByTagName("body")[0]),
              (e = document.createElement("img")),
              (e.src = ep + "?" + qs),
              b.parentNode.appendChild(e, b);
          })();
          break;

        case "ldg":
        default:
          (b = document.getElementsByTagName("body")[0]),
            (ee = document.createElement("img"));
          (ee.src =
            "https://tbl.tradedoubler.com/report?organization=1865651&event=383641&leadNumber=auto"),
            b.parentNode.appendChild(ee, b);
          break;
      }

      // Création de l'objet FormData
      var formData = new FormData(form);

      let dataObj = {};
      for (var pair of formData.entries()) {
        dataObj[pair[0]] = pair[1];
      }
      // console.table(dataObj);

      fetch(form.action, { method: "post", body: formData }).then(
        (response) => {
          if (response.status === 200) {
            this.image = true;
          }
        }
      );
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/style/form.scss";
</style>
